import React from "react";
import { Checkbox } from "antd";

export default ({ label, value, handleChange }) => (
  <Checkbox
    style={{ display: "block", marginLeft: 0 }}
    checked={value}
    onChange={handleChange}
  >
    {label}
  </Checkbox>
);
